/**
 * 选择器
 * @params {array} list 
 * @params {boolean} visible
 * @params {Function} setVisible
 * @params {Function} setForm
 * @returns JcPicker
 */
import { PureComponent, ReactNode } from "react";
import { CascadePicker} from "antd-mobile";

export default class JcPicker extends PureComponent<any,any>{

  constructor(props:any){
    super(props);
    this.state = {

    }
  }

  render(): ReactNode {
    const{list, visible, setVisible, setForm} = this.props;
    return(<div className="JcPicker">
      <CascadePicker style={{
          '--title-font-size': '14px',
          '--header-button-font-size': '14px',
          '--item-font-size': '14px',
          '--item-height': '40px',
        }}
        visible={visible}
        onClose={()=>{
          setVisible(false)
        }}
        onConfirm={(e) => {setForm(e)}}
        options={list}/>
    </div>)
  }
}
